import BigNumber from 'bignumber.js';
import { Natura } from '~/types/invoicing';

export const resolveVatExemption = (vatPercentage: string, taxExemption: Natura | null): Natura | null =>
  BigNumber(vatPercentage).isZero() ? taxExemption : null;

export const computeVatPercentage = (totalAmount: number, vatAmount: number) => {
  if (isNaN(totalAmount) || isNaN(vatAmount)) return NaN;

  if (totalAmount === 0) return 0;

  return vatAmount / (totalAmount - vatAmount);
};

export const transformVatToBase100 = (vatPercentage: BigNumber) => {
  if (vatPercentage.gte(1)) {
    return vatPercentage;
  }

  return vatPercentage.multipliedBy(100);
};
